/*
 * @Date: 2022-08-15 14:48:10
 * @LastEditTime: 2022-10-06 15:46:55
 * @Description:
 */
import { net_common } from "@/api/http";
export const API_DisplayEmployeeInfo = (...params) =>
    net_common.post("/api/STDSDC02C10/DisplayBopUsersInfoScreen", ...params);

export const API_ChangeAccountStatus = (...params) =>
    net_common.post("/api/STDSDC02C10/ChangeAccountStatus", ...params);

export const API_DeleteEmployeeInfo = (...params) =>
    net_common.post("/api/STDSDC02C10/DeleteEmployeeInfo", ...params);
